import React from 'react';
import DetalleReserva from '@components/MovilidadElectrica/DetalleReserva';

const DetalleReservaPage = () => {
  return <DetalleReserva />;
};

export default DetalleReservaPage;
